module.exports = __webpack_public_path__ + "img/header_bg.c4a827bc.png";